<template>
  <div :class="canUpload && saveInner && canUploadFile ? 'w-100': ''">
    <div class="d-inline-flex titleType">
      <p :is="titleTag" :class="titleClass" v-if="title">{{ title }}</p>
      <button
        v-if="canUpload && saveInner && canUploadFile"
        @click="updateImage"
        :disabled="!canUploadFile"
        class="btn btn-success"
      >
        Lưu
      </button>
    </div>
    <div class="img-list" v-if="fileType === 'image' && canUpload">
      <ul v-viewer class="m-0">
        <li v-for="(item, index) in fileUploads" :key="index">
          <a href="javascript:void(0)">
            <img :src="url(item) || item" />
          </a>
          <span v-if="canRemoveOldFile === true ? canUpload : canUpload && !!item.file" @click="removeFile(item.id)">
            <i class="bx bx-trash bx-sm"></i>
          </span>
        </li>
        <li v-if="canUpload && fileUploads.length < maxFile">
          <div
            class="add-img"
          >
            <span class="bx bx-plus text-center"></span>
            <input
              type="file"
              :ref="uniqueKey"
              :accept="accept"
              multiple
              @change="uploadFile"
            />
          </div>
        </li>
      </ul>
    </div>
    <div class="img-list" v-if="fileType === 'file' && canUpload">
      <ul class="m-0">
        <li v-for="(item, index) in fileUploads" :key="index">
          <a target="_blank" :href="urlWithFile(url(item) || item)">
            <img src="@/assets/img/file.jpg" />
          </a>
          <span v-if="canRemoveOldFile === true ? canUpload : canUpload && !!item.file" @click="removeFile(item.id)">
            <i class="bx bx-trash bx-sm"></i>
          </span>
        </li>
        <li v-if="canUpload && fileUploads.length < maxFile">
          <div
            class="add-img"
          >
            <span class="bx bx-plus text-center"></span>
            <input
              type="file"
              :ref="uniqueKey"
              :accept="accept"
              multiple
              @change="uploadFile"
            />
          </div>
        </li>
      </ul>
    </div>
    <div class="img-list" v-if="!canUpload">
      <ul class="m-0">
        <li
          v-for="(item, index) in fileUploads.filter(s => isFile(url(s) || s))"
          :key="index"
        >
          <a target="_blank" :href="urlWithFile(url(item) || item)">
            <img src="@/assets/img/file.jpg" />
          </a>
        </li>
      </ul>
      <ul class="m-0" v-viewer>
        <li
          v-for="(item, index) in fileUploads.filter(s => !isFile(url(s) || s))"
          :key="index"
        >
          <a href="javascript:void(0)">
            <img :src="url(item) || item" />
          </a>
        </li>
      </ul>
      <ul v-if="fileUploads.length <= 0">
        <li>
          <div class="add-img">
            <span class="font-size-12">Không có dữ liệu</span>
          </div>
        </li>
      </ul>
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'
import cloneDeep from 'lodash/cloneDeep'
export default {
  props: {
    lsData: {
      type: Array,
      require: true
    },
    keyUrl: {
      type: String,
      default: 'url'
    },
    fileType: {
      type: String,
      default: 'image'
    },
    titleTag: {
      type: String,
      default: 'p'
    },
    titleClass: {
      type: String,
      default: ''
    },
    title: {
      type: String
    },
    accept: {
      type: String,
      default: 'image/jpeg, image/png'
    },
    maxFile: {
      type: Number,
      default: 10
    },
    maxFileSize: {
      type: Number,
      default: 20
    },
    uniqueKey: {
      type: String,
      default: () => {
        return uuidv4()
      }
    },
    canUpload: {
      type: Boolean,
      default: true
    },
    saveInner: {
      type: Boolean,
      default: false
    },
    canRemoveOldFile: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      fileUploads: []
    }
  },
  watch: {
    lsData (val) {
      if (val) this.fileUploads = val ?? []
    }
  },
  computed: {
    canUploadFile () {
      return this.fileUploads.find(e => e.file)
    }
  },
  created () {
    if (this.lsData) {
      const data = this.lsData.map(s => {
        if (typeof s === 'string') {
          return {
            id: uuidv4(),
            [this.keyUrl]: s
          }
        }
        return s
      })
      this.fileUploads = cloneDeep(data) ?? []
    }
  },
  methods: {
    url (item) {
      return item?.[this.keyUrl]
    },
    isFile (filename) {
      var pattern = /\.pdf|doc|docx|xlsx|xls|mp4|mov|avi|mkv$/i
      return pattern.test(filename)
    },
    urlWithFile (filename) {
      var pattern = /\.pdf|doc|docx$/i
      if (pattern.test(filename)) return '/viewer/pdf?url=' + filename
      else return filename
    },
    removeFile (id) {
      // const file = this.fileUploads.find(s => s.id === id)
      // Sau này sẽ call api xoá file với các file có file.status === uploaded
      this.fileUploads = this.fileUploads.filter(s => s.id !== id)
      this.$emit('syncFile', this.fileUploads, this.uniqueKey)
    },
    validateFile (file) {
      if (this.fileUploads.length >= this.maxFile) {
        this.showFailMx(`Bạn chỉ được upload tối đa ${this.maxFile} file`)
        return false
      }
      if (this.accept !== '*/*') {
        const fomatUpload = this.accept.split(',').map(s => s.trim())
        if (!fomatUpload.some(type => file.type.startsWith(type.replace('/*', '')))) {
          this.showFailMx('Định dạng file của bạn không hợp lệ')
          return false
        }
      }
      if (file.size > this.maxFileSize * 1024 * 1024) {
        this.showFailMx(`Bạn chỉ được upload tối đa ${this.maxFileSize}MB`)
        return false
      }
      return true
    },
    uploadFile (e) {
      const files = e.target.files
      if (files.length > 0) {
        for (const file of files) {
          if (!this.validateFile(file)) return
          this.fileUploads.push({
            id: uuidv4(),
            name: file.name,
            [this.keyUrl]: URL.createObjectURL(file),
            file,
            type: this.uniqueKey
          })
        }
        this.$refs[this.uniqueKey].value = null
        this.$emit('syncFile', this.fileUploads, this.uniqueKey)
      }
    },

    updateImage () {
      this.$emit('updateImage', this.fileUploads, this.uniqueKey)
    }
  }
}
</script>
<style scoped>
.titleType {
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding-bottom: 5px;
}
li {
  list-style: none;
}
</style>
